<template>
  <div>
    <bookings-por-confirmar-tabla :data="data" />
  </div>
</template>

<script>
// Vuex
import { mapState, mapActions } from "vuex";

// Constantes
import { getBookingsPorConfirmar, getBookingsPorConfirmarFiltrados } from "../../../constants/lineas";

// Componentes
import BookingsPorConfirmarTabla from "../../../components/tablas/lineas/BookingsPorConfirmarTabla";

export default {
  components: { BookingsPorConfirmarTabla },
  data() {
    return {
      data: [],
    };
  },
  computed: {
    ...mapState(["token"]),
    ...mapState("lineas", ["dataDatatableBookingsPorConfirmarFiltrada"]),
  },
  methods: {
    // Acciones de Vuex
    ...mapActions([
      "AccionCambiar",
      "ActionSetLoading",
      "ActionSetLoadingTable",
    ]),
    ...mapActions("lineas", ["actionSetDatatableBookingsPorConfirmar"]),
    ...mapActions("lineas", [
      "actionSetDataListaNave",
      "actionSetDataListaPOD",
      "actionSetDataListaAnio",
      "actionSetDataListaPOL",
      "actionSetDataListaNaviera",
      "actionSetDataListaSemana",
      "actionSetDataListaCliente"
    ]),
    // Función para actualizar url en state
    actualizarURL() {
      let me = this;
      me.AccionCambiar(this.$route.path);
    },
    async setDataPorConfirmar(){
        
        const filters = {
            id: this.$route.query.id_by_country ?? null,
            referencia: "",
            no_booking: "",
            cliente: null,
            nave: "",
            naviera: null,
            pod: null,
            pol: null,
            semana_inicio: null,
            semana_termino: null,
            anio: ""
        } ;

        const dataFiltrada = await getBookingsPorConfirmarFiltrados(filters);
        this.actionSetDatatableBookingsPorConfirmar(dataFiltrada);
    },
    async getBookingPorConfirmar() {
      this.ActionSetLoadingTable(true);
      let dataBB = await getBookingsPorConfirmar(this.token);

      if( Object.keys( this.$route.query ).length > 0 ) {
        await this.setDataPorConfirmar() ;
      } else {
        this.actionSetDatatableBookingsPorConfirmar(dataBB.data_table);
      }

      // Filtros
      this.actionSetDataListaNave(dataBB.filtroNave);
      this.actionSetDataListaPOD(dataBB.filtroPod);
      this.actionSetDataListaPOL(dataBB.filtroPol);
      this.actionSetDataListaSemana(dataBB.filtroSemana);
      this.actionSetDataListaAnio(dataBB.filtroAnio);
      this.actionSetDataListaNaviera(dataBB.filtroNaviera);
      this.actionSetDataListaCliente(dataBB.filtroCliente);
    },
  },
  created() {
    // Ejecución de actualizarURL una vez que se carga el componente
    this.actualizarURL();
    this.getBookingPorConfirmar();
  },
  watch: {
    dataDatatableBookingsPorConfirmarFiltrada: function (_new) {
      if (_new) {
        this.data = _new;
      }
    },
  },
};
</script>
<style></style>
